import { ReactElement } from "react"
import { MdOutlineZoomOutMap } from "react-icons/md"
import { IconButton } from "../../IconButton"
import { FilterSectionProps } from "../FilterSectionWithExpandButton"
import { GlobalFilter } from "../GlobalFilter"

export function FilterSectionMapPage(props: FilterSectionProps): ReactElement {
	return (
		<div
			className={`flex items-center ${
				props.showGlobalFilter === true ? "justify-between" : "justify-end"
			} w-auto pb-2 text-headline text-gray-333`}
		>
			{props.showGlobalFilter === true ? (
				<GlobalFilter
					globalFilter={props.globalFilter}
					setGlobalFilter={props.setGlobalFilter}
					translationFunc={props.translationFunc}
				/>
			) : null}
			{props.onClick !== undefined ? (
				<IconButton
					variant={"filled-primary"}
					company={props.company === "soelvtrans" ? "soelvtrans" : "dipai"}
					size={"sm"}
					onClick={props.onClick}
				>
					<IconButton.Icon>{MdOutlineZoomOutMap}</IconButton.Icon>
				</IconButton>
			) : null}
		</div>
	)
}
